module.exports = __webpack_public_path__ + "static/aus-7378f1612301bc52d45fd97e29d59a15.jpg";